import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: 'row',
    marginTop: 10,
    marginBottom: 0,
  },
  reportTitle: {
    color: '#000000',
    fontSize: 12,
  },
});

const Tcb = () => (
  <View style={styles.titleContainer}>
    <Text style={styles.reportTitle}>TCB Realty</Text>
  </View>
);

export default Tcb;
